import {Component, HostListener, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {DynamoSEOService, DynamoHttpService, DynamoHttpInstance} from '@skillgmbh/dynamo';
import {environment} from '../environments/environment';
import {filter} from 'rxjs/operators';
import {isPlatformBrowser} from '@angular/common';
import {HeaderService} from './header.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
    })
export class AppComponent implements OnInit {
    protected wasPageScrolled = false;
    protected isStartPage = true;

    constructor(public router: Router,
                public headerService: HeaderService,
                private SEOService: DynamoSEOService,
                private httpService: DynamoHttpService,
                @Inject(PLATFORM_ID) private platformId: object) {
        this.SEOService.setAppIdentification('');

        this.registerDynamoHttpInstance('dynamo-cms', environment.dynamo_cms_proxy, false);
        this.registerDynamoHttpInstance('gastroflow-proxy', environment.gastroflow_proxy, false);
    }

    ngOnInit(): void {
        this.isStartPage = this.checkStartPage(this.router.url);

        this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd): void => {
                this.isStartPage = this.checkStartPage(event.urlAfterRedirects);
            });

        if (isPlatformBrowser(this.platformId)) {
            this.wasPageScrolled = window.scrollY > 8;
        }
    }

    @HostListener('window:scroll')
    onWindowScroll(): void {
        this.wasPageScrolled = window.scrollY > 8;
    }

    private checkStartPage(url: string): boolean {
        const path: string = url.split('?')[0].split('#')[0];

        return path === '/' || path === '/home';
    }

    private registerDynamoHttpInstance(key: string, url: string, authorization: boolean): void {
        this.httpService.registerInstance(key, {
            url: url,
            authorizationEnabled: authorization,
        } as DynamoHttpInstance);
    }
}
